import React from 'react'
import { getAnalytics } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'
import { /** enableIndexedDbPersistence, */ getFirestore } from 'firebase/firestore'
import { getPerformance } from 'firebase/performance'
import { getStorage } from 'firebase/storage'
import {
  FirebaseAppProvider as FirebaseAppProviderReactfire,
  FirestoreProvider,
  AuthProvider,
  StorageProvider,
  AnalyticsProvider,
  PerformanceProvider,
  useFirebaseApp
} from 'reactfire'

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
}

const InnnerFirebaseAppProvider: React.FC = ({ children }) => {
  // Firebase初期設定

  const app = useFirebaseApp()
  const firestore = getFirestore(app)
  const auth = getAuth(app)
  const storage = getStorage(app)
  const analytics = getAnalytics(app)
  const performance = getPerformance(app)

  // // HotReload用にtry/catchする
  // try {
  //   // オフラインの永続性処理
  //   enableIndexedDbPersistence(firestore, {})
  //     .then(() => {})
  //     .catch(err => {
  //       console.error('enablePersistence: Error', err)
  //     })
  // } catch (error) {
  //   console.log(error)
  // }

  return (
    <FirestoreProvider sdk={firestore}>
      <AuthProvider sdk={auth}>
        <StorageProvider sdk={storage}>
          <AnalyticsProvider sdk={analytics}>
            <PerformanceProvider sdk={performance}>{children}</PerformanceProvider>
          </AnalyticsProvider>
        </StorageProvider>
      </AuthProvider>
    </FirestoreProvider>
  )
}

export const FirebaseProvider: React.FC = ({ children }) => (
  <FirebaseAppProvider>
    <InnnerFirebaseAppProvider>{children}</InnnerFirebaseAppProvider>
  </FirebaseAppProvider>
)

export const FirebaseAppProvider: React.FC = ({ children }) => (
  <FirebaseAppProviderReactfire firebaseConfig={firebaseConfig}>{children}</FirebaseAppProviderReactfire>
)
